var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChromeStoreWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 135 40.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-4, .cls-5, .cls-6 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-8 {\n        fill: #515151;\n      }\n\n      .cls-9 {\n        fill: #4285f4;\n      }\n\n      .cls-10 {\n        fill: #0f9d58;\n      }\n\n      .cls-11 {\n        fill: #c6c6c6;\n      }\n\n      .cls-12 {\n        fill: #db4437;\n      }\n\n      .cls-13 {\n        fill: #aaa;\n      }\n\n      .cls-14 {\n        fill: #bababa;\n      }\n\n      .cls-15 {\n        fill: #999;\n      }\n\n      .cls-16 {\n        fill: #f1f1f1;\n      }\n\n      .cls-17 {\n        fill: #fff;\n      }\n\n      .cls-18 {\n        fill: #e5e5e5;\n      }\n\n      .cls-19 {\n        fill: #ffcd40;\n      }\n\n      .cls-20 {\n        fill: #eee;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.26,7.26v23.96c0,1.13.92,2.05,2.05,2.05h26.01c1.13,0,2.05-.92,2.05-2.05V7.26H6.26Zm18.48,5.48h-6.85c-.76,0-1.37-.61-1.37-1.37s.61-1.37,1.37-1.37h6.85c.76,0,1.37.61,1.37,1.37s-.61,1.37-1.37,1.37Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.26,7.26v23.96c0,1.13.92,2.05,2.05,2.05h26.01c1.13,0,2.05-.92,2.05-2.05V7.26H6.26Zm18.48,5.48h-6.85c-.76,0-1.37-.61-1.37-1.37s.61-1.37,1.37-1.37h6.85c.76,0,1.37.61,1.37,1.37s-.61,1.37-1.37,1.37Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.26,7.26v23.96c0,1.13.92,2.05,2.05,2.05h26.01c1.13,0,2.05-.92,2.05-2.05V7.26H6.26Zm18.48,5.48h-6.85c-.76,0-1.37-.61-1.37-1.37s.61-1.37,1.37-1.37h6.85c.76,0,1.37.61,1.37,1.37s-.61,1.37-1.37,1.37Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 21.32,
    cy: 31.22,
    r: 13.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 21.32,
    cy: 31.22,
    r: 13.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 21.32,
    cy: 31.22,
    r: 13.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 21.32,
    cy: 31.22,
    r: 13.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.26,7.26v23.96c0,1.13.92,2.05,2.05,2.05h26.01c1.13,0,2.05-.92,2.05-2.05V7.26H6.26Zm18.48,5.48h-6.85c-.76,0-1.37-.61-1.37-1.37s.61-1.37,1.37-1.37h6.85c.76,0,1.37.61,1.37,1.37s-.61,1.37-1.37,1.37Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 1422.69,
    cy: 1730.6,
    fx: 1422.69,
    fy: 1730.6,
    r: 155.79,
    gradientTransform: "translate(-349.5 -425.5) scale(.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    width: 135,
    height: 40.45,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m47.04,28.74c-1.07,0-1.96-.36-2.68-1.08s-1.08-1.62-1.08-2.7.36-1.98,1.08-2.7c.72-.72,1.61-1.08,2.68-1.08s1.98.39,2.66,1.18l-.65.63c-.49-.61-1.16-.92-2.01-.92-.79,0-1.45.27-2,.8-.54.53-.81,1.23-.81,2.09s.27,1.56.81,2.09,1.21.8,2,.8c.87,0,1.61-.35,2.22-1.05l.65.65c-.33.4-.74.71-1.24.95-.5.23-1.04.35-1.63.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m51.67,21.34v2.29l-.04.69h.04c.13-.24.35-.44.64-.6.29-.17.6-.25.93-.25.61,0,1.08.19,1.41.57.32.38.49.88.49,1.52v3.03h-.93v-2.89c0-.92-.41-1.38-1.22-1.38-.38,0-.7.15-.94.46-.24.31-.36.66-.36,1.07v2.74h-.93v-7.24h.93-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m57.15,28.58h-.93v-4.95h.89v.81h.04c.09-.27.29-.49.58-.67s.58-.26.85-.26.51.04.7.12l-.35.87c-.12-.05-.29-.07-.5-.07-.34,0-.64.13-.89.4-.26.27-.39.62-.39,1.05v2.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m60.02,24.21c.48-.5,1.09-.75,1.83-.75s1.35.25,1.83.75c.48.5.72,1.13.72,1.89s-.24,1.38-.72,1.89c-.48.5-1.09.75-1.83.75s-1.35-.25-1.83-.75c-.48-.5-.72-1.13-.72-1.89s.24-1.38.72-1.89Zm.69,3.19c.32.33.7.49,1.14.49s.82-.16,1.14-.49.48-.76.48-1.3-.16-.97-.48-1.3-.7-.49-1.14-.49-.82.16-1.14.49-.48.76-.48,1.3.16.97.48,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m65.15,28.58v-4.95h.89v.69h.04c.14-.24.36-.44.65-.6.29-.17.58-.25.87-.25.77,0,1.29.32,1.57.95.4-.63.98-.95,1.73-.95.59,0,1.03.19,1.32.56.3.37.44.88.44,1.52v3.03h-.93v-2.89c0-.5-.09-.85-.27-1.06s-.46-.31-.83-.31-.67.16-.9.47c-.24.31-.36.66-.36,1.06v2.74h-.93v-2.89c0-.5-.09-.85-.27-1.06s-.46-.31-.83-.31-.67.16-.9.47c-.24.31-.36.66-.36,1.06v2.74h-.93v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m76.01,28.74c-.75,0-1.36-.25-1.83-.75s-.7-1.13-.7-1.89c0-.72.23-1.34.68-1.86s1.04-.78,1.74-.78,1.32.24,1.76.72.66,1.12.66,1.92v.17h-3.92c.03.5.19.89.5,1.18s.67.44,1.08.44c.67,0,1.12-.28,1.35-.85l.83.34c-.16.38-.43.71-.8.97s-.83.39-1.37.39h.02Zm1.33-3.24c-.02-.28-.15-.55-.39-.81s-.59-.38-1.07-.38c-.34,0-.64.11-.89.32s-.43.51-.52.87c0,0,2.87,0,2.87,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m89.6,21.34l-1.93,7.24h-.95l-1.56-4.77h-.04l-1.56,4.77h-.95l-2.01-7.24h.97l1.53,5.69h.04l1.57-4.72h.87l1.57,4.72h.04l1.45-5.69h.97-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m92.02,28.74c-.75,0-1.36-.25-1.83-.75s-.7-1.13-.7-1.89c0-.72.23-1.34.68-1.86s1.04-.78,1.74-.78,1.32.24,1.76.72.66,1.12.66,1.92v.17h-3.92c.03.5.19.89.5,1.18s.67.44,1.08.44c.67,0,1.12-.28,1.35-.85l.83.34c-.16.38-.43.71-.8.97s-.83.39-1.37.39h.02Zm1.33-3.24c-.02-.28-.15-.55-.39-.81s-.59-.38-1.07-.38c-.34,0-.64.11-.89.32s-.43.51-.52.87c0,0,2.87,0,2.87,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m97.81,28.74c-.38,0-.72-.08-1.02-.24s-.52-.36-.67-.61h-.04v.69h-.89v-7.24h.93v2.29l-.04.69h.04c.15-.24.37-.44.67-.61s.64-.24,1.02-.24c.64,0,1.19.25,1.66.76s.7,1.13.7,1.88-.23,1.38-.7,1.88c-.46.51-1.02.76-1.66.76h0Zm-.15-.85c.43,0,.8-.16,1.11-.49s.47-.76.47-1.3-.16-.97-.47-1.3-.68-.49-1.11-.49-.81.16-1.12.49c-.31.32-.46.76-.46,1.3s.15.98.46,1.3.68.49,1.12.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m105.14,28.74c-.53,0-1.04-.17-1.54-.52s-.83-.83-.99-1.45l.85-.34c.1.4.31.73.62,1.01s.67.41,1.06.41.75-.11,1.04-.32.43-.5.43-.86c0-.4-.14-.72-.43-.94-.29-.22-.74-.42-1.36-.61-.64-.2-1.13-.46-1.46-.78-.33-.32-.5-.73-.5-1.23s.21-.97.62-1.35c.41-.38.95-.58,1.61-.58.61,0,1.11.15,1.5.46.38.31.63.64.75,1.01l-.85.35c-.06-.23-.21-.44-.45-.64-.24-.2-.55-.29-.92-.29s-.66.1-.92.3-.38.45-.38.74c0,.27.12.5.35.68.23.19.57.35,1.03.5.36.11.66.23.89.33.24.11.48.25.73.43s.43.4.56.67c.12.27.19.57.19.92s-.07.66-.22.94-.34.5-.58.66c-.24.16-.5.28-.77.37-.28.08-.56.13-.85.13h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m110.42,28.66c-.52,0-.92-.14-1.19-.41s-.41-.67-.41-1.17v-2.6h-.87v-.85h.87v-1.52h.93v1.52h1.21v.85h-1.21v2.53c0,.54.22.81.67.81.17,0,.31-.03.42-.08l.32.8c-.2.09-.45.13-.75.13h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m112.24,24.21c.48-.5,1.09-.75,1.83-.75s1.35.25,1.83.75.72,1.13.72,1.89-.24,1.38-.72,1.89c-.48.5-1.09.75-1.83.75s-1.35-.25-1.83-.75-.72-1.13-.72-1.89.24-1.38.72-1.89Zm.69,3.19c.32.33.7.49,1.14.49s.82-.16,1.14-.49.48-.76.48-1.3-.16-.97-.48-1.3-.7-.49-1.14-.49-.82.16-1.14.49-.48.76-.48,1.3.16.97.48,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m118.29,28.58h-.93v-4.95h.89v.81h.04c.09-.27.29-.49.58-.67s.58-.26.85-.26.51.04.7.12l-.35.87c-.12-.05-.29-.07-.5-.07-.34,0-.64.13-.89.4-.26.27-.39.62-.39,1.05v2.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m122.98,28.74c-.75,0-1.36-.25-1.83-.75s-.7-1.13-.7-1.89c0-.72.23-1.34.68-1.86s1.04-.78,1.74-.78,1.32.24,1.76.72.66,1.12.66,1.92v.17h-3.92c.03.5.19.89.5,1.18s.67.44,1.08.44c.67,0,1.12-.28,1.35-.85l.83.34c-.16.38-.43.71-.8.97s-.83.39-1.37.39h.02Zm1.33-3.24c-.02-.28-.15-.55-.39-.81s-.59-.38-1.07-.38c-.34,0-.64.11-.89.32s-.43.51-.52.87c0,0,2.87,0,2.87,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m43.82,17.34l2.07-5.48h.8l2.07,5.48h-.78l-.53-1.48h-2.3l-.54,1.48h-.79Zm1.55-2.14h1.82l-.9-2.47h-.03l-.9,2.47h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m50,17.34l-1.52-3.75h.77l1.1,2.91h.02l1.12-2.91h.75l-1.53,3.75h-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m53.8,17.46c-.4,0-.73-.11-1-.34s-.4-.53-.4-.91c0-.41.16-.73.47-.96.32-.23.71-.35,1.17-.35.41,0,.75.08,1.02.23v-.11c0-.28-.09-.5-.28-.66-.19-.17-.42-.25-.7-.25-.2,0-.39.05-.55.15-.17.1-.28.23-.34.4l-.64-.28c.09-.22.26-.43.51-.62s.59-.29,1.01-.29c.48,0,.88.14,1.19.42.32.28.47.68.47,1.19v2.26h-.67v-.52h-.03c-.28.43-.69.64-1.23.64Zm.11-.64c.29,0,.55-.11.79-.33s.36-.47.36-.77c-.2-.16-.5-.24-.9-.24-.34,0-.6.07-.77.22-.17.15-.26.32-.26.52,0,.18.08.33.24.44s.34.16.54.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m57.3,12.65c-.1.1-.21.15-.35.15s-.26-.05-.35-.15c-.1-.1-.15-.21-.15-.35s.05-.25.15-.35c.1-.1.21-.15.35-.15s.25.05.35.15c.1.1.15.21.15.35s-.05.26-.15.35Zm0,4.69h-.7v-3.75h.7v3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m58.92,17.34h-.7v-5.48h.7v5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m60.93,17.46c-.4,0-.73-.11-1-.34s-.4-.53-.4-.91c0-.41.16-.73.47-.96.32-.23.71-.35,1.17-.35.41,0,.75.08,1.02.23v-.11c0-.28-.09-.5-.28-.66-.19-.17-.42-.25-.7-.25-.2,0-.39.05-.55.15-.17.1-.28.23-.34.4l-.64-.28c.09-.22.26-.43.51-.62s.59-.29,1.01-.29c.48,0,.88.14,1.19.42.32.28.47.68.47,1.19v2.26h-.67v-.52h-.03c-.28.43-.69.64-1.23.64Zm.11-.64c.29,0,.55-.11.79-.33s.36-.47.36-.77c-.2-.16-.5-.24-.9-.24-.34,0-.6.07-.77.22-.17.15-.26.32-.26.52,0,.18.08.33.24.44s.34.16.54.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m65.64,17.46c-.29,0-.54-.06-.77-.18-.23-.12-.4-.28-.51-.46h-.03v.52h-.67v-5.48h.7v1.73l-.03.52h.03c.11-.18.28-.34.51-.46s.48-.18.77-.18c.48,0,.9.19,1.25.57s.53.86.53,1.42-.18,1.04-.53,1.42-.77.57-1.25.57h0Zm-.11-.64c.33,0,.61-.12.84-.37.23-.25.35-.58.35-.98s-.12-.74-.35-.98c-.23-.25-.52-.37-.84-.37s-.61.12-.85.37c-.23.24-.35.57-.35.99s.12.74.35.99c.23.24.51.37.85.37v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m68.73,17.34h-.7v-5.48h.7v5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m71.25,17.46c-.57,0-1.03-.19-1.38-.57s-.53-.85-.53-1.43c0-.55.17-1.01.52-1.41s.78-.59,1.32-.59,1,.18,1.34.54.5.85.5,1.45v.13h-2.97c.02.38.15.68.38.9.23.22.5.33.81.33.51,0,.85-.21,1.03-.64l.63.26c-.12.29-.32.53-.6.73-.28.2-.63.29-1.03.29h-.02Zm1.01-2.45c-.02-.21-.11-.42-.29-.61s-.45-.29-.81-.29c-.26,0-.49.08-.68.24s-.32.38-.39.66h2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m76.1,12.65c-.1.1-.21.15-.35.15s-.26-.05-.35-.15-.15-.21-.15-.35.05-.25.15-.35.21-.15.35-.15.26.05.35.15c.1.1.15.21.15.35s-.05.26-.15.35Zm0,4.69h-.7v-3.75h.7v3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m77.69,13.59v.52h.03c.1-.18.26-.33.48-.46.22-.12.45-.19.7-.19.46,0,.82.14,1.06.43s.37.67.37,1.15v2.3h-.7v-2.19c0-.69-.31-1.04-.93-1.04-.29,0-.53.12-.71.35s-.28.5-.28.81v2.07h-.7v-3.75h.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m84.47,17.4c-.39,0-.69-.1-.9-.31s-.31-.51-.31-.89v-1.97h-.66v-.64h.66v-1.15h.7v1.15h.92v.64h-.92v1.91c0,.41.17.61.5.61.13,0,.23-.02.32-.06l.24.6c-.15.07-.34.1-.57.1h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m86.3,11.86v1.73l-.03.52h.03c.1-.18.26-.33.48-.46.22-.12.45-.19.7-.19.46,0,.82.14,1.06.43s.37.67.37,1.15v2.3h-.7v-2.19c0-.69-.31-1.04-.93-1.04-.29,0-.53.12-.71.35s-.28.5-.28.81v2.07h-.7v-5.48h.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m91.44,17.46c-.57,0-1.03-.19-1.38-.57s-.53-.85-.53-1.43c0-.55.17-1.01.52-1.41s.78-.59,1.32-.59,1,.18,1.34.54.5.85.5,1.45v.13h-2.97c.02.38.15.68.38.9.23.22.5.33.81.33.51,0,.85-.21,1.03-.64l.63.26c-.12.29-.32.53-.6.73-.28.2-.63.29-1.03.29h-.02Zm1.01-2.45c-.02-.21-.11-.42-.29-.61s-.45-.29-.81-.29c-.26,0-.49.08-.68.24s-.32.38-.39.66h2.17Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m6.26,7.26h30.12v26.01H6.26V7.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m24.74,10h-6.85c-.76,0-1.37.61-1.37,1.37s.61,1.37,1.37,1.37h6.85c.76,0,1.37-.61,1.37-1.37s-.61-1.37-1.37-1.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m10.38,18.21v15.96h5.82l5.12-8.87h13.01v-7.09H10.38Zm0,0v15.96h5.82l5.12-8.87h13.01v-7.09H10.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m8.31,44.22h12.38l5.75-5.75v-4.3h-10.24l-7.89-13.53v23.57h0Zm0,0h12.38l5.75-5.75v-4.3h-10.24l-7.89-13.53v23.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m21.32,25.31l5.12,8.87-5.74,10.05h13.63v-18.92s-13.01,0-13.01,0Zm0,0l5.12,8.87-5.74,10.05h13.63v-18.92s-13.01,0-13.01,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 21.32,
    cy: 31.22,
    r: 5.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 21.32,
    cy: 31.22,
    r: 4.73
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m6.26,7.26h30.12v13.01H6.26V7.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m6.26,20.1h30.12v.17H6.26v-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m6.26,20.27h30.12v.17H6.26v-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m24.74,12.74h-6.85c-.73,0-1.32-.57-1.36-1.28v.09c0,.76.61,1.37,1.37,1.37h6.85c.76,0,1.37-.61,1.37-1.37v-.09c-.04.72-.64,1.28-1.36,1.28h-.02ZM6.26,7.26v.17h30.12v-.17H6.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.89,10h6.85c.73,0,1.32.57,1.36,1.28v-.09c0-.76-.61-1.37-1.37-1.37h-6.85c-.76,0-1.37.61-1.37,1.37v.09c.04-.72.64-1.28,1.36-1.28h.02Zm16.43,23.1H8.31c-1.13,0-2.05-.92-2.05-2.05v.17c0,1.13.92,2.05,2.05,2.05h26.01c1.13,0,2.05-.92,2.05-2.05v-.17c0,1.13-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m6.26,7.26v23.96c0,1.13.92,2.05,2.05,2.05h26.01c1.13,0,2.05-.92,2.05-2.05V7.26H6.26Zm18.48,5.48h-6.85c-.76,0-1.37-.61-1.37-1.37s.61-1.37,1.37-1.37h6.85c.76,0,1.37.61,1.37,1.37s-.61,1.37-1.37,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m4.89,3.84h32.86v32.86H4.89V3.84Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeStoreWhite);
export default __webpack_public_path__ + "static/media/ChromeStore-White.b1a08d34c9026bce6aabdc8f5d2ccdf5.svg";
export { ForwardRef as ReactComponent };